import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import WhatsAppList from '@/components/modules/whatsapp/WhatsAppList'
import WhatsAppChat from '@/components/modules/whatsapp/WhatsAppChat'
import WhatsAppCampaign from '@/components/modules/whatsapp/WhatsAppCampaign'
import WhatsAppSettings from '@/components/modules/whatsapp/settings/WhatsAppSettings'
import WhatsappCampaignAnalytics from '@/components/modules/whatsapp/WhatsappCampaignAnalytics'
import WhatsAppStatisticsDashboard from '@/components/modules/whatsapp/WhatsAppStatisticsDashboard'

export const whatsapp = [
	{
		path: '/whatsapp',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/whatsapp/',
					text: 'Chat',
					icon: 'mdi-message-text',
				},
				{
					to: '/whatsapp/templates',
					text: 'Template',
					icon: 'mdi-file-document-outline',
				},
				{
					to: '/whatsapp/lists',
					text: 'Liste',
					icon: 'mdi-format-list-bulleted',
				},
				{
					to: '/whatsapp/campaigns',
					text: 'Campagne',
					icon: 'mdi-bullhorn',
				},
				{
					to: '/whatsapp/statistics',
					text: 'Statistiche',
					icon: 'mdi-chart-line',
				},
			],
		},
		children: [
			{
				path: '',
				name: 'whatsapp-chat',
				beforeEnter: ifAuthenticatedOnline,
				component: WhatsAppChat,
				meta: {
					title: 'WhatsApp Chat'
				}
			},
			{
				path: 'templates',
				name: 'whatsapp-templates',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				meta: {
					title: 'Template WhatsApp'
				},
				props: {
					modelDef: 'templates-whatsapp',
					actionIcon: 'mdi-message-text',
					title: 'Template WhatsApp',
					defaultInput: { type: 'whatsapp' }
				}
			},
			{
				path: 'lists',
				name: 'whatsapplists-index',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				meta: {
					title: 'Liste WhatsApp'
				},
				props: {
					modelDef: 'whatsapplists',
					actionIcon: 'mdi-whatsapp',
					title: 'Liste WhatsApp'
				}
			},			
			{
				path: 'campaigns',
				name: 'whatsappcampaigns-index',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				meta: {
					title: 'Campagne WhatsApp'
				},
				props: {
					modelDef: 'whatsappcampaigns',
					actionIcon: 'mdi-bullhorn',
					title: 'Campagne WhatsApp',
					styleClass: 'mb-offset'
				}
			},
			{
				path: 'statistics',
				name: 'whatsapp-statistics',
				beforeEnter: ifAuthenticatedOnline,
				component: WhatsAppStatisticsDashboard,
				meta: {
					title: 'Statistiche WhatsApp'
				}
			},
		],
	},
	{
		path: '/whatsapp/templates/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/whatsapp/templates/' + parseInt(route.params.id) + '/',
					text: 'Template WhatsApp',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-whatsapp-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template WhatsApp'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'templates-whatsapp',
					modelClass: 'template',
					activities: true,
					noEdit: true,
				}),
			},
		]
	},
	{
		path: '/whatsapp/campaigns/create',
		name: 'whatsappcampaigns-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: {
			modelDef: 'whatsappcampaigns',
			modelClass: 'whatsappcampaign'
		},
		meta: {
			title: 'Nuova Campagna WhatsApp'
		}
	},
	{
		path: '/whatsapp/campaigns/:id/edit',
		name: 'whatsappcampaigns-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'whatsappcampaigns',
			modelClass: 'whatsappcampaign',
			id: parseInt(route.params.id)
		}),
		meta: {
			title: 'Modifica Campagna WhatsApp'
		}
	},
	{
		path: '/whatsapp/campaigns/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/whatsapp/campaigns/' + parseInt(route.params.id) + '/',
					text: 'Campagna',
				},
				{
					to: 'analytics',
					text: 'Statistiche',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'whatsappcampaigns-show',
				beforeEnter: ifAuthenticatedOnline,
				component: WhatsAppCampaign,
				meta: {
					title: 'Campagna'
				},
				props: (route) => ({
					id: parseInt(route.params.id)
				}),
			},
			{
				path: '/whatsapp/campaigns/:id/analytics',
				beforeEnter: ifAuthenticatedOnline,
				component: WhatsappCampaignAnalytics,
				meta: {
					title: 'Statistiche'
				},
				props: (route) => ({
					id: parseInt(route.params.id)
				}), 
			},
		]		
	},

	// WhatsApp Lists CRUD routes
	{
		path: '/whatsapp/lists/create',
		name: 'whatsapplists-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'whatsapplists',
			redirect: route.params.redirect
		}),
	},
	{
		path: '/whatsapp/lists/:id/edit',
		name: 'whatsapplists-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'whatsapplists',
			id: parseInt(route.params.id)
		}),
	},
	{
		path: '/whatsapp/lists/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '',
					text: 'WhatsApp List',
				},
			],
		},
		children: [
			{
				path: '/whatsapp/lists/:id',
				name: 'whatsapplists-show',
				beforeEnter: ifAuthenticatedOnline,
				component: WhatsAppList,
				meta: {
					title: 'WhatsApp List'
				},
				props: (route) => ({
					id: parseInt(route.params.id)
				}),
			},
		]
	},

	// Settings WhatsApp
	{
		path: '/settingswhatsapp',
		name: 'settingswhatsapp',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingswhatsapp',
					text: 'Configurazione',
				},
			],
		},
		children: [
			{
				path: '/settingswhatsapp/',
				beforeEnter: ifAuthenticatedOnline,
				component: WhatsAppSettings,
				meta: {
					title: 'Impostazioni WhatsApp'
				}
			},
		],
	},
]